/* eslint-disable */

import {
  RACButton,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACTooltip,
  Typography,
} from '@rentacenter/racstrap';
import i18n from 'i18next'; // Import i18next
import React, { useContext, useState } from 'react';
import { PhoneInstructionsModal } from './PhoneInstructionsModal';
import { withContactStyles, WrappedComponentProps } from './withContactStyles';
import { abbrev, formatPhoneNumber } from '../../../utils/utils';
import { ApiStateWrapper } from '../../../common/ApiStateWrapper/ApiStateWrapper';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import clsx from 'clsx';
import { StoreStateContext, useStoreDetails } from '../../../context/Store/StoreProvider';
import { AddressType } from '../../../types/types';
import { useTranslation } from 'react-i18next';

const coCustomerContentTestId = 'coCustomerContentTestId';
const ContactInformationCoCustomerContent_ = ({
  classes,
  onLogClicked,
  onError,
}: WrappedComponentProps) => {
  const {
    coCustomerDetails,
    loadingCoCustomer,
    hasApiErrorCoCustomer,
    isCommunicationAllowed,
    countryCode,
    isLegalHoldProtected
  } = useCustomerDetails();

  const { t } = useTranslation();

  const [showPhoneInstructionModal, setShowPhoneInstructionModal] =
    useState<boolean>(false);

  const [phoneInstructionsPhoneId, setPhoneInstructionsPhoneId] =
    useState<string>('');
  const [phoneInstructionsNotes, setPhoneInstructionsNotes] =
    useState<string>('');

  const popUpPhoneInstructions = (
    mykey: string,
    myvalue: string | null
  ): void => {
    setPhoneInstructionsPhoneId(mykey);
    setPhoneInstructionsNotes(myvalue == null ? '' : myvalue);
    setShowPhoneInstructionModal(true);
  };

  const closePhoneInstructionModal = () => {
    setShowPhoneInstructionModal(false);
  };

  const updatePhoneNotes = (phoneId: string, notes: string) => {
    coCustomerDetails?.phones?.forEach((one) => {
      if (phoneId == one.phoneId) {
        one.note = notes;
      }
    });
  };

  const { store } = useStoreDetails();
  const {enableCountryCode} = useContext(StoreStateContext);
  const storeState = store?.stateAbb?.toUpperCase();
  const MASSACHUSETTS = 'MA';
  
  const countryAbb = store?.countryAbb?.toUpperCase();
  const regionCode = countryCode.filter((item)=> item.abbreviation == countryAbb)
  const { addresses } = coCustomerDetails || {};
  const primaryAddress = addresses?.filter(
    (address) => address.addressType === AddressType.PRIMARY
  );
  const customerAddress =
    primaryAddress && primaryAddress.length > 0
      ? primaryAddress[0]
      : {
          city: '',
          state: '',
          postalCode: '',
          addressLine1: '',
          addressLine2: '',
          addressId: '',
        };

  const renderTableHead = () => (
    <>
      <RACTableCell>{t('Name')}</RACTableCell>
      <RACTableCell>{t('Phone Number')}</RACTableCell>
      <RACTableCell>{t('Type')}</RACTableCell>
      <RACTableCell>{t('Best Time to Call')}</RACTableCell>
      <RACTableCell>{t('Phone Instructions')}</RACTableCell>
      <RACTableCell>{t('# Contacts Today')}</RACTableCell>
      <RACTableCell>{t('Last Call Result')}</RACTableCell>
      <RACTableCell align="center">{t('Action')}</RACTableCell>
    </>
  );

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const renderTableContent = () => (
    <>
      {coCustomerDetails &&
        coCustomerDetails.phones?.map((phone) => (
          <RACTableRow
            backgroundColor="white"
            key={phone.phoneId || phone.personalReferenceId}
          >
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {phone.phoneId
                  ? `${coCustomerDetails.firstName || ''} ${
                      coCustomerDetails.lastName || ''
                    }`
                  : `${phone.firstName || ''} ${phone.lastName || ''}`}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {formatPhoneNumber(
                  phone.phoneNumber?.split('.')[0],
                  isLegalHoldProtected ||
                    !isCommunicationAllowed ||
                    (customerAddress.state === MASSACHUSETTS &&
                      phone.primary !== 'Y') ||
                    (storeState === MASSACHUSETTS && phone.primary !== 'Y'),
                  (enableCountryCode == 1 ? (phone.countryCode ? phone.countryCode : (regionCode[0]?.countryCodeValue ?? '')): '')
                )}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {i18n.t(phone.phoneTypeDesc) ||
                  i18n.t(phone.relationshipTypeDesc || '')}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {i18n.t(phone.callTimeTypeDesc) ||
                  i18n.t(phone.bestTimeToCallDesc || '')}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              {showPhoneInstructionModal && (
                <PhoneInstructionsModal
                  phoneId={phoneInstructionsPhoneId}
                  note={phoneInstructionsNotes}
                  onChange={updatePhoneNotes}
                  onClose={closePhoneInstructionModal}
                  onError={onError}
                />
              )}
              {phone.phoneId && (
                <RACButton
                  variant="text"
                  size="small"
                  color="primary"
                  onClick={() =>
                    popUpPhoneInstructions(phone?.phoneId, phone?.note)
                  }
                  disabled={isLegalHoldProtected}
                >
                  {phone.note ? (
                    <Typography noWrap variant="body2" color="primary">
                      <RACTooltip title={i18n.t(phone?.note)}>
                        <span>{abbrev(i18n.t(phone?.note))}</span>
                      </RACTooltip>
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      color="primary"
                      className={classes.underline}
                    >
                      {t('Add')}
                    </Typography>
                  )}
                </RACButton>
              )}
            </RACTableCell>
            <RACTableCell>
              <Typography
                align="center"
                variant="body2"
                className={classes.tableContentColor}
              >
                {phone.communicationsToday}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography noWrap variant="body2" color="primary">
                <RACTooltip
                  title={i18n.t(phone.lastCallResultDescription || '')}
                >
                  <span>
                    {abbrev(i18n.t(phone.lastCallResultDescription || ''))}
                  </span>
                </RACTooltip>
              </Typography>
            </RACTableCell>
            <RACTableCell className={classes.center}>
              <RACButton
                variant="outlined"
                color="primary"
                className={classes.logButton}
                onClick={() =>
                  onLogClicked(
                    String(coCustomerDetails.customerId),
                    phone.phoneNumber
                  )
                }
                disabled={
                  !phone.phoneNumber ||
                  !isCommunicationAllowed ||
                  isLegalHoldProtected
                }
              >
                {t('Log')}
              </RACButton>
            </RACTableCell>
          </RACTableRow>
        ))}
    </>
  );
  return (
    <div
      className={clsx(
        classes.listWrapper,
        (loadingCoCustomer || hasApiErrorCoCustomer) && classes.tabContentLoader
      )}
      data-testid={coCustomerContentTestId}
    >
      <ApiStateWrapper
        loading={loadingCoCustomer}
        hasApiError={hasApiErrorCoCustomer}
        response={coCustomerDetails}
        successContent={
          <RACTable
            renderTableHead={renderTableHead}
            renderTableContent={renderTableContent}
          />
        }
      />
    </div>
  );
};

export const ContactInformationCoCustomerContent = (props: any) =>
  withContactStyles(props)(ContactInformationCoCustomerContent_);
